import React, { useEffect, useState } from 'react'
import { useTranslate } from './TranslationText'
import EahsForm from './EahsForm';
import { getSpecialPrizesByShowId } from '../pages/sharedAPI/lookUpApis';
import { truncateString } from '../helper/truncateString';

export default function SpecialPrizesSection({ showId }) {
    const { translate } = useTranslate();

    const [prizeList, setPrizeList] = useState([]);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        getSpecialPrizesByShowId(showId).then((res) => {
            setPrizeList(res);
        });
    }, [])

    return (
        prizeList.length > 0 && <div className="pt-5">
            <EahsForm key={'champion'} isSectionTitle={true} title={translate("web.specialPrizes", "special prizes ")}>
                {prizeList.map((item, index) => (
                    <div key={item?.prizeName} className={prizeList?.length > 4 ? "col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-main" : "col-xl-3 col-lg-4 col-md-6 col-sm-12"}>
                        <div className="p-main bg-white border-15 p-3 h-100 border borderf3 homeWhiteBg" >
                            <div className="col-md-12 d-flex justify-content-between align-items-center">
                                <span className="horseCardTitle  mb-1" style={{minHeight:45}}> {item?.prizeName}  </span>
                            </div>
                            <div className="whiteSpacer col-12" />
                            <div
                                className="col-sm-12 mb-main" style={{maxHeight:175 , overflowY:'auto'}}
                            >
                                {item?.horses?.map((horse) => (
                                    <div className="JudgesTableRow" style={{overflow:'hidden'}}>
                                        <i className="fa fa-chess-knight w-unset red" ></i>
                                        <div className="showDetailsJudesName horseCardDescription fw-bold  ms-3 ">
                                            {windowWidth > 991
                                                ? truncateString(
                                                    `${horse?.horseNumber} - ${horse?.horseName}`
                                                )
                                                : horse?.horseNumber +
                                                " - " +
                                                horse?.horseName}
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                ))}
            </EahsForm>
        </div>
    )
}
